import {
  vs2jen2VersionListConstants,
  vs2jen2VersionUploadConstants,
  vs2jen2VersionDeleteConstants,
  vs2jen2VersionConstants,
} from "../_redux-constants";
import { vs2jen2VersionListService } from "../../_services";

function getVs2jen2VersionList(queryParams) {
  function getVs2jen2VersionListLoad() {
    return { type: vs2jen2VersionListConstants.VS2JEN2VERSION_LIST_LOADING };
  }
  function vs2jen2VersionListSuccess(data) {
    return {
      type: vs2jen2VersionListConstants.VS2JEN2VERSION_LIST_SUCCESS,
      data,
    };
  }
  function vs2jen2VersionListFailure(error) {
    return {
      type: vs2jen2VersionListConstants.VS2JEN2VERSION_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getVs2jen2VersionListLoad());
    return vs2jen2VersionListService.getVs2jen2VersionList(queryParams).then(
      (data) => {
        dispatch(vs2jen2VersionListSuccess(data));
      },
      (error) => {
        dispatch(vs2jen2VersionListFailure(error?.toString()));
      }
    );
  };
}

function uploadVs2jen2Version(queryParams) {
  function vs2jen2VersionUploadLoad() {
    return {
      type: vs2jen2VersionUploadConstants.VS2JEN2VERSION_UPLOAD_LOADING,
    };
  }
  function vs2jen2VersionUploadSuccess(data) {
    return {
      type: vs2jen2VersionUploadConstants.VS2JEN2VERSION_UPLOAD_SUCCESS,
      data,
    };
  }
  function vs2jen2VersionUploadFailure(error) {
    return {
      type: vs2jen2VersionUploadConstants.VS2JEN2VERSION_UPLOAD_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(vs2jen2VersionUploadLoad());
    return new Promise((resolve, reject) => {
      vs2jen2VersionListService.uploadVs2jen2Version(queryParams).then(
        (data) => {
          dispatch(vs2jen2VersionUploadSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(vs2jen2VersionUploadFailure(error));
          reject(error);
        }
      );
    });
  };
}

function deleteVs2jen2Version(queryParams) {
  function vs2jen2VersionDeleteLoad() {
    return {
      type: vs2jen2VersionDeleteConstants.VS2JEN2VERSION_DELETE_LOADING,
    };
  }
  function vs2jen2VersionDeleteSuccess(data) {
    return {
      type: vs2jen2VersionDeleteConstants.VS2JEN2VERSION_DELETE_SUCCESS,
      data,
    };
  }
  function vs2jen2VersionDeleteFailure(error) {
    return {
      type: vs2jen2VersionDeleteConstants.VS2JEN2VERSION_DELETE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(vs2jen2VersionDeleteLoad());
    return vs2jen2VersionListService.deleteVs2jen2Version(queryParams).then(
      (data) => {
        dispatch(vs2jen2VersionDeleteSuccess(data));
      },
      (error) => {
        dispatch(vs2jen2VersionDeleteFailure(error?.toString()));
      }
    );
  };
}

function vs2jen2Version(queryParams) {
  function vs2jen2VersionLoad() {
    return { type: vs2jen2VersionConstants.VS2JEN2VERSION_LOADING };
  }
  function vs2jen2VersionSuccess(data) {
    return { type: vs2jen2VersionConstants.VS2JEN2VERSION_SUCCESS, data };
  }
  function vs2jen2VersionFailure(error) {
    return { type: vs2jen2VersionConstants.VS2JEN2VERSION_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(vs2jen2VersionLoad());
    return vs2jen2VersionListService.showVs2jen2Version(queryParams).then(
      (data) => {
        dispatch(vs2jen2VersionSuccess(data));
      },
      (error) => {
        dispatch(vs2jen2VersionFailure(error?.toString()));
      }
    );
  };
}

export const vs2jen2VersionListActions = {
  getVs2jen2VersionList,
  uploadVs2jen2Version,
  deleteVs2jen2Version,
  vs2jen2Version,
};
